module.exports = __webpack_public_path__ + "img/icon_sec2_05.0b44aa5c.png";